import { en } from './en'
import { fr } from './fr'

export const eventManagementPage = { en, fr }
